export var BRIDGE_RESPONSE_TYPE;
(function (BRIDGE_RESPONSE_TYPE) {
    BRIDGE_RESPONSE_TYPE["SUCCESS"] = "SUCCESS";
    BRIDGE_RESPONSE_TYPE["API_RESPONSE_ERROR"] = "API_RESPONSE_ERROR";
    BRIDGE_RESPONSE_TYPE["API_UNREGISTER"] = "API_UNREGISTER";
    BRIDGE_RESPONSE_TYPE["REJECT_BRIDGE_BY_CURPAGE"] = "REJECT_BRIDGE_BY_CURPAGE";
    BRIDGE_RESPONSE_TYPE["AB_MISSED"] = "AB_MISSED";
    BRIDGE_RESPONSE_TYPE["BRIDGE_ERROR"] = "BRIDGE_ERROR";
    BRIDGE_RESPONSE_TYPE["ONLY_SUPPORT_ELECTRON"] = "ONLY_SUPPORT_ELECTRON";
    BRIDGE_RESPONSE_TYPE["PREVENT_USER_CROSSWIN_PUT"] = "PREVENT_USER_CROSSWIN_PUT";
    BRIDGE_RESPONSE_TYPE["BRIDGE_UNKNOWN"] = "BRIDGE_UNKNOWN";
})(BRIDGE_RESPONSE_TYPE || (BRIDGE_RESPONSE_TYPE = {}));
export const BRIDGE_RESPONSE_CODE = {
    [BRIDGE_RESPONSE_TYPE.SUCCESS]: 0,
    [BRIDGE_RESPONSE_TYPE.API_RESPONSE_ERROR]: -1,
    [BRIDGE_RESPONSE_TYPE.API_UNREGISTER]: -2,
    [BRIDGE_RESPONSE_TYPE.REJECT_BRIDGE_BY_CURPAGE]: -15,
    [BRIDGE_RESPONSE_TYPE.AB_MISSED]: -16,
    [BRIDGE_RESPONSE_TYPE.BRIDGE_ERROR]: -17,
    [BRIDGE_RESPONSE_TYPE.ONLY_SUPPORT_ELECTRON]: -18,
    [BRIDGE_RESPONSE_TYPE.BRIDGE_UNKNOWN]: -19,
    [BRIDGE_RESPONSE_TYPE.PREVENT_USER_CROSSWIN_PUT]: 20,
};
